<!--
Copyright (C) Cocouz Oy 2017 - All Rights Reserved
-->
<template>
  <div class="col-lg-5 col-xl-4">

            <div class="aside position-none" id="aside" v-bind:style="stickyObject" :class="{'stop-float': footerCollided}">
            <MPCollider v-collision="['groupone']" @collide="onCollideHandler" @non-collide="nonCollideHandler" @collide-groupone="onGroupOneCollide" @non-collide-groupone="nonGroupOneCollide" />
              <!-- Price -->

              <div class="price" v-if="!noRegusRoom">

                <h3 class="price__value" ><pulse-loader :color="'grey'" id="loadingThing" v-if="isLoading"></pulse-loader><span v-if="!isLoading">{{ currencySymbol }}{{ selectedPrice }}</span><span v-if="!isLoading" class="price__decimals">{{selectedPrice_decimal}}</span></h3>
                <p class="price__definition" > {{ strings.perPerson}}</p>
              </div>


              <!-- Form -->
              <form action="" class="form aside__basics">
                <div class="input-group">
                  <label class="form__label  input-group__item input-group__item--longer">
                    {{ strings.startdate }}
                    <input v-model="s_date" class="flatpickr form__input js-datepicker flatpickr-input" id="fpick" ref="fpick" :placeholder="strings.whenyourmeetingis">
                  </label>

                  <vue-timepicker v-model="s_time" class="vueTimePicker" :minute-interval="15" hide-clear-button></vue-timepicker>
                </div>

                <div class="input-group">
                  <label class="form__label input-group__item input-group__item--longer">{{ strings.length }}
                    <select name="length" class="form__input form__select" :class="{'ie': isIE }" v-model="s_meetingLength">
                      <option value="2">2 h</option>
                      <option value="3">3 h</option>
                      <option value="4">4 h</option>
                      <option value="5">5 h</option>
                      <option value="6">6 h</option>
                      <option value="7">7 h</option>
                      <option value="8">8 h</option>
                      <option value="9">9 h</option>
                      <option value="10">10 h</option>
                    </select>
                  </label>
                  <label class="form__label input-group__item">{{ strings.attendees }}
                    <input type="number" class="form__input" :placeholder="strings.howmany" v-model.lazy="s_delegates" v-debounce="300" >
                  </label>

                </div>

              </form>

              <!-- Room and / or package selection -->

              <ul class="tabs tabs--aside">
                <li class="tabs__item" :class="{'current' : packageCurrent}" data-tab="tab-1"  v-if="!isPackageTabRemoved">{{ strings.packagetab}}</li>
                <li class="tabs__item" :class="{'current' : roomCurrent}" data-tab="tab-2"  v-if="!isPackageTabRemoved">{{ strings.roomtab }}</li>
              </ul>

              <div class="tabs__container">

                <div id="tab-2" class="tabs__content" v-if="!showEnquiry" :class="{'current' :roomCurrent}">

                   <label class="form__label">{{ strings.room }} <span class="js-expand-details form__details--room" @click="toggleDetails()">{{ detailsRoomText }}</span>
                     <!-- apply this class for validation:  form--invalid -->
                     <select name="room" class="form__input form__select" v-model="s_room" :disabled="noRegusRoom">
                       <option :value="item.id" v-for="(item, key) in roomInfo" :key="key" >{{ item.title }}</option>
                     </select>
                     <!--<p class="form__note">Choose your package</p>-->
                   </label>

                   <label class="form__label">{{ strings.seatingorder }} <span class="js-expand-details form__details--room" @click="toggleDetails()">{{ detailsRoomText }}</span>
                    <p class="regus_layout">{{ this.$store.state.regus_layout }}</p>
                  </label>

                </div>

                <div class="aside__summary" v-if="!noRegusRoom">
                  <div class="aside__total">{{ strings.total }}<span class="aside__detail"> ({{ strings.inclVat }})</span></div>
                  <div class="aside__value" v-if="!isLoading">{{ totalPrice }} {{ currencySymbol }}</div>
                </div>
                <div class="tabs__cta">
                  <button href="" class="button button--success button--full tabs__button" :class="{'button--disabled':noRegusRoom}" @click="createBooking()" v-if="!showEnquiry" :disabled="noRegusRoom">{{ strings.continue }}</button>
                  <ul class="checklist checklist--spacing checklist--info">
                    <li class="checklist__item checklist__item--info">{{ strings.allenquiry }}</li>
                    <li class="checklist__item checklist__item--info hideForBE" >{{ strings.direct }}</li>
                    <li class="checklist__item checklist__item--info hideForBE">{{ strings.call }} {{ phoneNumber }} {{ strings.ifyouneed }} </li>
                  </ul>
                  <p class="tabs__enquiry-note" v-if="showEnquiry">{{ strings.plzsendenquiry }}</p>
                </div>
              </div>

            </div>
          </div>
</template>

<script>
  //import flatPickr from 'vue-flatpickr-component';
  import fpickr from "flatpickr"
  import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
  //import locale for flatpickr.
  import { Russian } from "flatpickr/dist/l10n/ru.js";
  import { Finnish } from "flatpickr/dist/l10n/fi.js"
  import { Danish } from "flatpickr/dist/l10n/da.js"
  import { French } from "flatpickr/dist/l10n/fr.js"
  import { German } from "flatpickr/dist/l10n/de.js"
  import { Italian } from "flatpickr/dist/l10n/it.js"
  import { Latvian } from "flatpickr/dist/l10n/lv.js"
  import { Spanish } from "flatpickr/dist/l10n/es.js"
  import { Swedish } from "flatpickr/dist/l10n/sv.js"
  import { Mandarin } from "flatpickr/dist/l10n/zh.js"
  import { Czech } from "flatpickr/dist/l10n/cs.js"
  import { english } from "flatpickr/dist/l10n/default.js"

  // import locacle for vee-validate.
  import arabic from 'vee-validate/dist/locale/ar';
  import russian from "vee-validate/dist/locale/ru";
  import finnish from "vee-validate/dist/locale/fi"
  import danish from "vee-validate/dist/locale/da"
  import french from "vee-validate/dist/locale/fr"
  import german from "vee-validate/dist/locale/de"
  import italian from "vee-validate/dist/locale/it"
  //import latvian from "vee-validate/dist/locale/lv"
  import spanish from "vee-validate/dist/locale/es"
  import swedish from "vee-validate/dist/locale/sv"
  import chinese from "vee-validate/dist/locale/zh_CN"

  import MPCollider from './Collider';
  import Vue from 'vue'
  import VueResource from 'vue-resource';
  import moment from 'moment';

  import VuePhoneInput from './VuePhoneInput'
  const { detect } = require('detect-browser');
  const browser = detect();
  import * as hf from '../assets/misc/helperFunctions.js'

  import VueTimepicker from 'vue2-timepicker'

  Vue.use(VueResource);

  export default {
    props: ['lang'],
    components: {
      MPCollider,
      PulseLoader,
      VuePhoneInput,
      VueTimepicker
    },
    data () {
      return {
        date: null,
        stickyObject:  {},
        vInfo : '',
        s_email: '',
        s_phone: '',
        s_name: '',
        pInfo: '',
        roomPrice: '',
        roomTotalPrice: '',
        s_lname: '',
        s_company: '',
        s_additional_info: '',
        isIE: false,
        details: true,
        detailsPackage: true,
        detailsRoomText: this.$store.state.strings.details,
        detailsPackageText: this.$store.state.strings.details,
        noCC: false,
        s_phone_logged_in: '',
        s_timee: '10:15'
      }
    },
    created () {
      this.$validator.localize('ar', arabic);
      this.$validator.localize('ru', russian);
      this.$validator.localize('fi', finnish);
      this.$validator.localize('da', danish);
      this.$validator.localize('fr', french);
      this.$validator.localize('de', german);
      this.$validator.localize('it', italian);
      this.$validator.localize('es', spanish);
      this.$validator.localize('sv', swedish);
      this.$validator.localize('zh', chinese);

      // start with english locale.
      this.$validator.localize('en');
    },
    methods: {
      reRender(lang) {
        this.$validator.localize(lang);
        switch (lang) {
          case 'ru':
            fpickr.localize(Russian);
            break;
          case 'fi':
            fpickr.localize(Finnish);
            break;
          case 'da':
            fpickr.localize(Danish);
            break;
          case 'fr':
            fpickr.localize(French);
            break;
          case 'de':
            fpickr.localize(German);
            break;
          case 'it':
            fpickr.localize(Italian);
            break;
          case 'lv':
            fpickr.localize(Latvian);
            break;
          case 'es':
            fpickr.localize(Spanish);
            break;
          case 'sv':
            fpickr.localize(Swedish);
            break;
          case 'zh':
            fpickr.localize(Mandarin);
            break;
          case 'cs':
            fpickr.localize(Czech);
            break;
          case 'en':
            fpickr.localize(english);
            break;
          default:
            break;
        }
        let date = moment(this.$store.state.date, 'DD-MM-YYYY');
        let defaultDate = moment();

        let finalDate = '';
        if(date > defaultDate){
          finalDate = date;
        } else {
          this.$store.commit('setDate', defaultDate.format('DD-MM-YYYY'));
          finalDate = defaultDate;
        }

        let time = moment(this.$store.state.time, 'HH:mm');

        fpickr("#fpick", {
          altInput: true,
          dateFormat: 'd-m-Y',
          defaultDate: finalDate.format('DD-MM-YYYY'),
          minDate: defaultDate.format('DD-MM-YYYY'),

        });

        fpickr("#fpick_time", {
          dateFormat: 'H:i',
          enableTime: true,
          defaultHour: time.format('HH'),
          defaultMinute: time.format('mm'),
          minuteIncrement: 30,
          time_24hr: true,
          noCalendar: true
        });
      },
      onCollideHandler (collider) {
      },
      nonCollideHandler (collider) {
        this.stickyObject =  {
          position: 'fixed',
          width: '336.66px',
          top: '121px',
          transition: 'all .3 ease-in'
        }
      },
      onGroupOneCollide (collider) {
        this.stickyObject =  {
          position: 'initial',
          width: '336.66px',
          top: '0',
          transition: 'all .3 ease-in'
        }
      },
      nonGroupOneCollide (collider) {
      },
      createBooking() {

        this.$store.commit('setProcessing', 'yes');
        let roomIF = [];
        let startD = this.$store.state.datetime;
        let startT = this.$store.state.time;
        let endD = moment(startD, 'DD-MM-YYYY HH:mm');
        let mt_length = '';
        let baseUrl = this.$store.state.baseUrl;

        let lang = this.$store.state.selectedLang;
        if(lang == 'en'){
          lang = '';
        } else {
          lang = '/' + lang;
        }

        if(this.$store.state.meeting_length == 'overnight'){
          mt_length = 24;
        } else if(this.$store.state.meeting_length == 'twodays'){
          mt_length = 36;
        } else {
          mt_length = parseInt(this.$store.state.meeting_length);
        }

        endD = endD.add(mt_length, 'hours');
        endD = endD.format('DD-MM-YYYY HH:mm');

        let roomList = this.$store.state.regusRoomInfo;
        roomList.forEach(element => {
          if(element.id == this.$store.state.selectedRegusRoom){
            roomIF['name'] = element.title;
            roomIF['code'] = element.id;
            roomIF['photo'] = element.room_pictures;
            roomIF['room_layout'] = element.room_layout;
            roomIF['room_price_no_vat'] = element.no_vat_price;
          }
        });
       
        let sentData = {
          'search_result_id' : roomIF['code'],
          'mt_length' : mt_length
        }

        Vue.http.post(baseUrl + '/apiv2/regus/temporarybook', sentData).then(response => {
          if(response.data){
            let checkout_items = {
              'startD' : startD,
              'startT' : startT,
              'endD' : endD,
              'currency': this.$store.state.venueInfo.currency_code,
              'currencySymbol' : this.$store.state.venueInfo.currency,
              'room' : roomIF['name'],
              'room_code' : roomIF['code'],
              'delegates' : this.$store.state.delegates,
              'layout' : roomIF['room_layout'],
              'venue' : this.$store.state.venueInfo.title,
              'venue_id': this.$store.state.venueInfo.id,
              'roomPhoto' : roomIF['photo'],
              'roomPrice_NoVAT' : roomIF['room_price_no_vat'],
              'roomPrice' : this.$store.state.roomPrice,
              'roomTotalPrice' : this.$store.state.roomTotalPrice,
              'reservationID': response.data.temporaryReservationID,
              //'services': response.data.services,
            };

            let services = response.data.services;

            // Set Checkout Items cookie.

            this.$cookie.set('checkout_items', JSON.stringify(checkout_items), { expires: '20m' });
            localStorage.setItem('services', JSON.stringify(services));


            // If booking.com here we set some cookies for the thank you page.
            let site_url = window.location.host;
            if(site_url == 'booking.meetingpackage.com' || site_url == 'meetingpackage.com'){
              let check_in_date = moment(this.$store.state.date, 'DD-MM-YYYY').format('YYYY-MM-DD');
              let check_out_date = moment(check_in_date, 'YYYY-MM-DD').add(1, 'days').format('YYYY-MM-DD');
              let latlon = this.$store.state.venueInfo.latlon.split(',');
              let latitude = latlon[0];
              let longitude = latlon[1];
              this.$cookie.set('bk_check_in_date', check_in_date);
              this.$cookie.set('bk_check_out_date', check_out_date);
              this.$cookie.set('bk_latitude', latitude);
              this.$cookie.set('bk_longitude', longitude);
            }

            if(this.$cookie.get('regus_cart_expiration')){
              this.$cookie.delete('regus_cart_expiration');
            }

            // Redirect to Regus Checkout page.
            let url = '';
            url = baseUrl + lang + '/book'
            window.location.href = url;

          } else {
            alert('There is error while processing your order. Please reload the page.');
          }
        });

        
      },
    },
    watch: {
      lang: function(value) {
        this.reRender(value)
      },
    },
    mounted() {
      fpickr.localize(english);
      fpickr("#fpick", {
          altInput: true,
          dateFormat: "d-m-Y",
      });
      fpickr("#fpick_time", {
          dateFormat: "H:i",
          enableTime: true,
      });

      // check what browser
      if (browser) {
        if(browser.name == 'ie' && parseFloat(browser.version) > 10 ) {
          this.isIE = true;
        }
      }

      let lang = this.$store.state.selectedLang;
      this.reRender(lang);
    },
    computed: {
      noRegusRoom () {
          return this.$store.state.noRegusRoom
      },
      userPhone() {
        return this.$store.state.userPhone;
      },
      countryCode() {
        return this.$store.state.countryPhoneCode;
      },
      isPackageTabRemoved() {
        return this.$store.state.isPackageTabRemoved;
      },
      isLoading() {
        return this.$store.state.isLoading;
      },
      strings () {
	      return this.$store.state.strings
      },
      isDisabled() {
        if(this.$store.state.currentTab == 'room'){
          return this.$store.state.isRoomFormDisabled;
        } else {
          return this.$store.state.isPackageFormDisabled;
        }
      },
      userInfo() {
        return this.$store.state.userInfo;
      },
      venueInfo(value) {
        this.vInfo = this.$store.state.venueInfo;
        return this.$store.state.venueInfo;
      },
      packageCurrent() {
        if(this.$store.state.currentTab != 'package'){
          return false;
        } else {
          return true;
        }
      },
      roomCurrent() {
        if(this.$store.state.currentTab == 'package'){
          return false;
        } else {
          return true;
        }
      },
      roomInfo() {
        return this.$store.state.regusRoomInfo;
      },
      selectedPrice(){
        return this.$store.state.selectedPrice;
      },
      selectedPrice_decimal(){
        return this.$store.state.selectedPrice_decimal;
      },
      currencySymbol(){
        return this.$store.state.currencySymbol;
      },
      footerCollided () {
        return this.$store.state.footerCollided
      },
      showEnquiry () {
        this.$cookie.delete('instant_booking');
        return this.$store.state.showEnquiryForm;
      },
      s_room: {
        get: function () {
          return this.$store.state.selectedRegusRoom
        },
        set: function (selectedRoom) {
          this.$store.state.regusRoomInfo.forEach(el => {
            if(el.id == selectedRoom){
              this.$store.dispatch('changeRoomRegus', el);
            }
          })
        }
      },
      s_meetingLength: {
        get: function () {
          return this.$store.state.meeting_length
        },
        set: function (meetingLength) {
          this.$store.commit('setMeetingLength', meetingLength);
          this.$cookie.set('_pref_mt', meetingLength);
          this.$store.dispatch('getRoomRegus');
          if(document.documentElement.clientWidth > 1023){
            this.$scrollTo('#showingRoomPackage');
          }
        }
      },
      s_delegates: {
        get: function () {
          return this.$store.state.delegates || 1;
        },
        set: function (delegates) {
          if(delegates == '' || delegates == 0 || delegates == '0'){
            delegates = 1;
          }
          this.$store.commit('setDelegates', delegates);
          this.$cookie.set('_pref_qty', delegates);
          this.$store.dispatch('getRoomRegus');
          if(document.documentElement.clientWidth > 1023){
            this.$scrollTo('#showingRoomPackage');
          }
        }
      },
      s_date: {
        get: function () {
          return this.$store.state.date
        },
        set: function (date) {
          this.$store.commit('setDate', date);
          this.$store.dispatch('getRoomRegus');

          // Set to cookie as well.
          let lang = this.$store.state.selectedLang;
          let datetime_cookie_name = lang + '_pref_dt';  
          let datetime = moment(this.$store.state.datetime, 'DD-MM-YYYY HH:mm');
          datetime = datetime.format('D MMMM, YYYY @ HH:mm');
          this.$cookie.set(datetime_cookie_name, datetime);
        }
      },
      s_time: {
        get: function () {
          let timeArr = this.$store.state.time.split(':');
          //return this.$store.state.time
          return {
            HH: timeArr[0],
            mm: timeArr[1]
          }
        },
        set: function (time) {
          let combinedTime = time.HH + ':' + time.mm;
          this.$store.commit('setTime', combinedTime);
          this.$store.dispatch('getRoomRegus');


          // Set to cookie as well.
          let lang = this.$store.state.selectedLang;
          let datetime_cookie_name = lang + '_pref_dt';  
          let datetime = moment(this.$store.state.datetime, 'DD-MM-YYYY HH:mm');
          datetime = datetime.format('D MMMM, YYYY @ HH:mm');
          this.$cookie.set(datetime_cookie_name, datetime);
        }
      },
      totalPrice() {
        let totalPrice = this.$store.state.price;
        this.$store.commit('setRoomTotalPrice', parseFloat(totalPrice).toFixed(2));

        let delegates = parseInt(this.$store.state.delegates);
        let price = parseFloat(totalPrice / delegates).toFixed(2);
        this.$store.commit('setRoomPrice', price);

        return parseFloat(totalPrice).toFixed(2);
      },
      currentTab() {
        return this.$store.state.currentTab;
      },
      delegates() {
        return parseInt(this.$store.state.delegates);
      },
      phoneNumber(){
        let selectedLang = this.$store.state.selectedLang;
        let phoneNumberList = this.$store.state.phoneNumberList;
        if (phoneNumberList[selectedLang]){
          return phoneNumberList[selectedLang];
        } else {
          return phoneNumberList['en'];
        }
      }
    }
  }
</script>

<style scope>
  .v-spinner {
    margin-left: 0;
  }

  .regus_layout {
    display: block;
    margin: .25em 0 0;
    width: 100%;
    padding: 0 .5em;
    height: 38px;
    line-height: 38px;
    font-size: 16px;
    border-radius: 5px;
    box-shadow: none;
    transition: all .35s cubic-bezier(.2,.7,.3,1);
    background-color: #fff;
    font-weight: lighter;
}

</style>
